import IconBase, { type IconProps } from '@yoweb/ui/components/Icon/IconBase';

export const ArrowLeftCompactIcon = (props: IconProps) => (
  <IconBase viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5303 2.21967C10.8232 2.51256 10.8232 2.98744 10.5303 3.28033L5.81066 8L10.5303 12.7197C10.8232 13.0126 10.8232 13.4874 10.5303 13.7803C10.2374 14.0732 9.76256 14.0732 9.46967 13.7803L4.21967 8.53033C3.92678 8.23744 3.92678 7.76256 4.21967 7.46967L9.46967 2.21967C9.76256 1.92678 10.2374 1.92678 10.5303 2.21967Z"
      fill="CurrentColor"
    />
  </IconBase>
);

export default ArrowLeftCompactIcon;
